const PLACEHOLDER_TITLES = new Set([
  'processing...',
  'processing…',
  'unknown title',
])

const STAGE_LABELS = {
  starting: 'Starting',
  fetching_metadata: 'Getting song details',
  downloading: 'Downloading audio',
  preparing_audio: 'Preparing audio',
  normalizing: 'Preparing audio',
  separating: 'Separating vocals',
  transcribing: 'Transcribing lyrics',
  refining_lyrics: 'Refining lyrics',
  cleaning_lyrics: 'Refreshing lyrics',
  preparing_files: 'Preparing files',
  saving_files: 'Saving song',
  validating: 'Checking song',
  finalizing: 'Finishing up',
  completed: 'Ready',
}

const usefulTitle = (value) => {
  const normalized = typeof value === 'string' ? value.trim() : ''
  return normalized && !PLACEHOLDER_TITLES.has(normalized.toLowerCase())
    ? normalized
    : null
}

export const getProcessingYoutubeId = (job) => {
  if (job?.song?.youtubeId) return job.song.youtubeId
  if (job?.youtubeId) return job.youtubeId
  return job?.youtubeUrl?.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/)?.[1] ?? null
}

export const getProcessingTitle = (job) => {
  return usefulTitle(job?.song?.title)
    || usefulTitle(job?.title)
    || (getProcessingYoutubeId(job) ? 'YouTube song' : 'Submitted song')
}

export const getProcessingArtist = (job) => {
  return job?.song?.artist?.trim?.()
    || job?.artist?.trim?.()
    || 'Getting artist details...'
}

export const getProcessingThumbnailUrl = (job) => {
  const explicitUrl = job?.song?.thumbnailUrl || job?.thumbnailUrl
  if (explicitUrl) return explicitUrl

  const youtubeId = getProcessingYoutubeId(job)
  return youtubeId ? `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg` : null
}

export const getProcessingProgress = (job) => {
  const progress = Number(job?.progress)
  if (!Number.isFinite(progress)) return 0
  return Math.round(Math.max(0, Math.min(100, progress)))
}

export const getProcessingStage = (job) => {
  if (job?.currentStage === 'cleaning_lyrics') {
    return STAGE_LABELS.cleaning_lyrics
  }

  if (job?.status === 'pending' || job?.status === 'queued') {
    return 'Waiting to start'
  }

  const explicitStage = STAGE_LABELS[job?.currentStage]
  if (explicitStage) return explicitStage

  const progress = getProcessingProgress(job)
  if (progress < 8) return 'Starting'
  if (progress < 10) return 'Getting song details'
  if (progress < 21) return 'Downloading audio'
  if (progress < 25) return 'Preparing audio'
  if (progress < 50) return 'Separating vocals'
  if (progress < 65) return 'Transcribing lyrics'
  if (progress < 80) return 'Refining lyrics'
  if (progress < 85) return 'Preparing files'
  if (progress < 95) return 'Saving song'
  return 'Finishing up'
}
